// @flow
import * as React from 'react';
import TypeaheadCache from 'app/common/react/components/MyBoardsTypeaheadProvider/TypeaheadCache';
import withResource, { type Resource } from 'app/common/lib/react/withResource';

type OwnProps<T> = {|
  children: (results: Array<T>) => React.Node,
  clientResults?: Array<T>,
  fieldSetKey: string,
  query: string,
|};

type HocProps<T> = {|
  resource: Resource<Array<T>>,
|};

type Props<T> = {|
  ...OwnProps<T>,
  ...HocProps<T>,
|};

function SearchMyBoards<T>({
  children,
  clientResults,
  resource: { data: serverResults },
}: Props<T>) {
  return <TypeaheadCache results={clientResults || serverResults}>{children}</TypeaheadCache>;
}

export default withResource(
  {
    name: 'SearchMyBoardsResource',
    key: 'resource',
    options: <T>({ fieldSetKey, query }: OwnProps<T>) => ({
      field_set_key: fieldSetKey,
      query,
    }),
  },
  {
    // do not fetch from the server if results are already determined on the client side
    dangerouslyDisableFetch: <T>({ clientResults }: OwnProps<T>) => !!clientResults,
  },
)(SearchMyBoards);
